import React from "react";

const SceneView = ({ color = "#000000", size = "20" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.49189 12.0913L6.33987 8.2433C6.57088 8.01229 6.68639 7.89678 6.81958 7.85351C6.93674 7.81544 7.06294 7.81544 7.1801 7.85351C7.31329 7.89678 7.4288 8.01229 7.6598 8.2433L11.4821 12.0656M8.1665 8.75L9.83987 7.07663C10.0709 6.84562 10.1864 6.73012 10.3196 6.68684C10.4367 6.64877 10.5629 6.64877 10.6801 6.68684C10.8133 6.73012 10.9288 6.84562 11.1598 7.07663L12.8332 8.75M5.83317 5.25C5.83317 5.89433 5.31084 6.41667 4.6665 6.41667C4.02217 6.41667 3.49984 5.89433 3.49984 5.25C3.49984 4.60567 4.02217 4.08333 4.6665 4.08333C5.31084 4.08333 5.83317 4.60567 5.83317 5.25ZM3.9665 12.25H10.0332C11.0133 12.25 11.5033 12.25 11.8777 12.0593C12.2069 11.8915 12.4747 11.6238 12.6424 11.2945C12.8332 10.9201 12.8332 10.4301 12.8332 9.45V4.55C12.8332 3.56991 12.8332 3.07986 12.6424 2.70552C12.4747 2.37623 12.2069 2.10852 11.8777 1.94074C11.5033 1.75 11.0133 1.75 10.0332 1.75H3.9665C2.98641 1.75 2.49637 1.75 2.12202 1.94074C1.79274 2.10852 1.52502 2.37623 1.35724 2.70552C1.1665 3.07986 1.1665 3.56991 1.1665 4.55V9.45C1.1665 10.4301 1.1665 10.9201 1.35724 11.2945C1.52502 11.6238 1.79274 11.8915 2.12202 12.0593C2.49637 12.25 2.98641 12.25 3.9665 12.25Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SceneView;
